// export const getStatusWithSuspendedCheck = (rowData) => {
//   // Handle blocked/suspended (-1)
//   if (rowData.agentStatus === "-1" || rowData.agentStatus === -1) {
//     const statusComments = rowData.comments?.toLowerCase().trim();
//     if (statusComments?.includes("suspended")) {
//       return "Suspended";
//     }
//     return "Blocked";
//   }

//   // Handle active (1)
//   if (rowData.agentStatus === "1" || rowData.agentStatus === 1) {
//     return "Active";
//   }

//   // Handle unknown (0) or any other invalid value
//   if (rowData.agentStatus === "0" || rowData.agentStatus === 0) {
//     return "Unknown";
//   }

//   // Default fallback for any unexpected values
//   return "Unknown";
// };
export const getStatusWithSuspendedCheck = (status, comments) => {
  // Handle blocked/suspended (-1)
  if (status === "-1" || status === -1) {
    const statusComments = comments?.toLowerCase().trim();
    if (statusComments?.includes("suspended")) {
      return "Suspended";
    }
    return "Blocked";
  }

  // Handle active (1)
  if (status === "1" || status === 1) {
    return "Active";
  }

  // Handle unknown (0) or any other invalid value
  if (status === "0" || status === 0) {
    return "Unknown";
  }

  // Default fallback for any unexpected values
  return "Unknown";
};

// export const getStatusWithSuspendedCheck = (statusOrRowData, comments) => {
//   let status, allComments;

//   // Accept both (rowData) object form and (status, comments) separate form
//   if (statusOrRowData !== null && typeof statusOrRowData === "object") {
//     status = statusOrRowData.agentStatus;
//     // Check both private note and message-to-agent for "suspended"
//     allComments = [
//       statusOrRowData.comments,
//       statusOrRowData.agentStatusComments,
//     ]
//       .filter(Boolean)
//       .join(" ")
//       .toLowerCase()
//       .trim();
//   } else {
//     status = statusOrRowData;
//     allComments = comments?.toLowerCase().trim() ?? "";
//   }

//   if (status === "-1" || status === -1) {
//     if (allComments.includes("suspended")) {
//       return "Suspended";
//     }
//     return "Blocked";
//   }

//   if (status === "1" || status === 1) {
//     return "Active";
//   }

//   if (status === "0" || status === 0) {
//     return "Unknown";
//   }

//   return "Unknown";
// };

export const getAgentStatusStyle = (
  agentStatus,
  comments,
  agentStatusComments,
) => {
  const statusComments = [comments, agentStatusComments]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .trim();

  if (agentStatus === "1" || agentStatus === 1) {
    return {
      bg: "bg-green-50",
      border: "border-green-200",
      dot: "bg-green-500",
      text: "text-green-700",
    };
  }
  if (
    (agentStatus === "-1" || agentStatus === -1) &&
    statusComments?.includes("suspended")
  ) {
    return {
      bg: "bg-orange-50",
      border: "border-orange-200",
      dot: "bg-orange-400",
      text: "text-orange-600",
    };
  }
  if (agentStatus === "-1" || agentStatus === -1) {
    return {
      bg: "bg-red-50",
      border: "border-red-200",
      dot: "bg-red-500",
      text: "text-red-700",
    };
  }
  return {
    bg: "bg-gray-50",
    border: "border-gray-200",
    dot: "bg-gray-400",
    text: "text-gray-600",
  };
};

export const agentVerificationStatusClassName = (verifiedStatus) => {
  switch (verifiedStatus) {
    case 1:
      return "bg-green-100 text-green-800 border-green-200 text-xs font-semibold";
    case 2:
      return "bg-yellow-100 text-yellow-800 border-yellow-200 text-xs font-semibold";
    case 3:
      return "bg-red-100 text-red-800 border-red-200 text-xs font-semibold";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200 text-xs font-semibold";
  }
};

export const agenVerificationStatusHelper = (verifiedStatus) => {
  switch (verifiedStatus) {
    case 1:
      return "Verified";
    case 2:
      return "Pending Verification";
    case 3:
      return "Rejected";
    default:
      return "Unverified";
  }
};
